import React, { Component } from "react";
import IPSDataService from "../services/ips.service";
import Captcha from "demos-react-captcha";

export default class Contact extends Component {
    constructor(props) {
      super(props);
      
      this.onChangeTitle = this.onChangeTitle.bind(this);
      this.onChangeEmail = this.onChangeEmail.bind(this);
      this.onChangePhone = this.onChangePhone.bind(this);
      this.onChangeCountry = this.onChangeCountry.bind(this);
      this.saveMessage = this.saveMessage.bind(this);
      this.onChangeCaptcha = this.onChangeCaptcha.bind(this);


      this.state = {
        id: null,
        title: "",
        email:"",
        phone:"",
        country: "Saudi Arabia",
        submitted: false,
        captchacheck:false,
      };


      

    }

    onChangeCaptcha(value) {
      this.setState({
        captchacheck: value
      });
    }

    onChangeTitle(e) {
        this.setState({
          title: e.target.value
        });
      }
    
      onChangeEmail(e) {
        this.setState({
          email: e.target.value
        });
      }
    
      onChangePhone(e) {
        this.setState({
          phone: e.target.value
        });
      }
    
      onChangeCountry(e) {
        this.setState({
          country: e.target.value
        });
      }

    saveMessage() {

      document.getElementById("successMessage").innerHTML= '';
      document.getElementById("errorMessage").innerHTML= '';
        var data = {
          title: this.state.title,
          email: this.state.email,
          phoneno: this.state.phone,
          country: this.state.country,
          type:'investment_advice'
        };

        const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if(this.state.email!="")
        {
           if (reg.test(this.state.email) === false){
               
               document.getElementById("errorMessage").innerHTML= "Invalid email address.";
               return false;
           }
          }

          if (this.state.captchacheck != true){
        
            document.getElementById("errorMessage").innerHTML= "Please fill valid captcha";
            return false;
        }
           
    
        IPSDataService.sendmessage(data)
          .then(response => {
            this.setState({
              title: response.data.title,
              email: response.data.email,
              submitted: true
            });
            //document.getElementById("successMessage").innerHTML= 'Your message has been sent to HR.';
            console.log(response.data);
          })
          .catch(e => {
            document.getElementById("errorMessage").innerHTML= e.response.data.message+"Please fill all fields.";
            console.log(e);
          });
      }

render() {
  const countryList = ["Afghanistan",	"Albania",	"Algeria",	"American Samoa",	"Andorra",	"Angola",	"Anguilla",	"Antarctica",	"Antigua and Barbuda",	"Argentina",	"Armenia",	"Aruba",	"Australia",	"Austria",	"Azerbaijan",	"Bahamas",	"Bahrain",	"Bangladesh",	"Barbados",	"Belarus",	"Belgium",	"Belize",	"Benin",	"Bermuda",	"Bhutan",	"Bolivia (Plurinational State of)",	"Bonaire, Sint Eustatius and Saba",	"Bosnia and Herzegovina",	"Botswana",	"Bouvet Island",	"Brazil",	"British Indian Ocean Territory",	"Brunei Darussalam",	"Bulgaria",	"Burkina Faso",	"Burundi",	"Cabo Verde",	"Cambodia",	"Cameroon",	"Canada",	"Cayman Islands",	"Central African Republic",	"Chad",	"Chile",	"China",	"Christmas Island",	"Cocos (Keeling) Islands",	"Colombia",	"Comoros",	"Congo (the Democratic Republic of the)",	"Congo",	"Cook Islands",	"Costa Rica",	"Croatia",	"Cuba",	"Curaçao",	"Cyprus",	"Czechia",	"Côte d'Ivoire",	"Denmark",	"Djibouti",	"Dominica",	"Dominican Republic",	"Ecuador",	"Egypt",	"El Salvador",	"Equatorial Guinea",	"Eritrea",	"Estonia",	"Eswatini",	"Ethiopia",	"Falkland Islands [Malvinas]",	"Faroe Islands",	"Fiji",	"Finland",	"France",	"French Guiana",	"French Polynesia",	"French Southern Territories",	"Gabon",	"Gambia",	"Georgia",	"Germany",	"Ghana",	"Gibraltar",	"Greece",	"Greenland",	"Grenada",	"Guadeloupe",	"Guam",	"Guatemala",	"Guernsey",	"Guinea",	"Guinea-Bissau",	"Guyana",	"Haiti",	"Heard Island and McDonald Islands",	"Holy See",	"Honduras",	"Hong Kong",	"Hungary",	"Iceland",	"India",	"Indonesia",	"Iran (Islamic Republic of)",	"Iraq",	"Ireland",	"Isle of Man",	"Israel",	"Italy",	"Jamaica",	"Japan",	"Jersey",	"Jordan",	"Kazakhstan",	"Kenya",	"Kiribati",	"Korea (the Democratic People's Republic of)",	"Korea (the Republic of)",	"Kuwait",	"Kyrgyzstan",	"Lao People's Democratic Republic",	"Latvia",	"Lebanon",	"Lesotho",	"Liberia",	"Libya",	"Liechtenstein",	"Lithuania",	"Luxembourg",	"Macao",	"Madagascar",	"Malawi",	"Malaysia",	"Maldives",	"Mali",	"Malta",	"Marshall Islands",	"Martinique",	"Mauritania",	"Mauritius",	"Mayotte",	"Mexico",	"Micronesia (Federated States of)",	"Moldova (the Republic of)",	"Monaco",	"Mongolia",	"Montenegro",	"Montserrat",	"Morocco",	"Mozambique",	"Myanmar",	"Namibia",	"Nauru",	"Nepal",	"Netherlands",	"New Caledonia",	"New Zealand",	"Nicaragua",	"Niger",	"Nigeria",	"Niue",	"Norfolk Island",	"Northern Mariana Islands",	"Norway",	"Oman",	"Pakistan",	"Palau",	"Palestine, State of",	"Panama",	"Papua New Guinea",	"Paraguay",	"Peru",	"Philippines",	"Pitcairn",	"Poland",	"Portugal",	"Puerto Rico",	"Qatar",	"Republic of North Macedonia",	"Romania",	"Russian Federation",	"Rwanda",	"Réunion",	"Saint Barthélemy",	"Saint Helena, Ascension and Tristan da Cunha",	"Saint Kitts and Nevis",	"Saint Lucia",	"Saint Martin (French part)",	"Saint Pierre and Miquelon",	"Saint Vincent and the Grenadines",	"Samoa",	"San Marino",	"Sao Tome and Principe",	"Saudi Arabia",	"Senegal",	"Serbia",	"Seychelles",	"Sierra Leone",	"Singapore",	"Sint Maarten (Dutch part)",	"Slovakia",	"Slovenia",	"Solomon Islands",	"Somalia",	"South Africa",	"South Georgia and the South Sandwich Islands",	"South Sudan",	"Spain",	"Sri Lanka",	"Sudan",	"Suriname",	"Svalbard and Jan Mayen",	"Sweden",	"Switzerland",	"Syrian Arab Republic",	"Taiwan",	"Tajikistan",	"Tanzania, United Republic of",	"Thailand",	"Timor-Leste",	"Togo",	"Tokelau",	"Tonga",	"Trinidad and Tobago",	"Tunisia",	"Turkey",	"Turkmenistan",	"Turks and Caicos Islands",	"Tuvalu",	"Uganda",	"Ukraine",	"United Arab Emirates",	"United Kingdom of Great Britain and Northern Ireland",	"United States Minor Outlying Islands",	"United States of America",	"Uruguay",	"Uzbekistan",	"Vanuatu",	"Venezuela (Bolivarian Republic of)",	"Viet Nam",	"Virgin Islands (British)",	"Virgin Islands (U.S.)",	"Wallis and Futuna",	"Western Sahara",	"Yemen",	"Zambia",	"Zimbabwe",	"Åland Islands"];
    return (
        <div>
          
         
         
          <div className="container" style={{padding:'5px'}}>
          
          </div>
          <div className="investment-advice-form-container">
      <div className="row">
        <div className="col-md-6">
          <div id="investment-advice-title">Get investment advice for your unique needs</div>
          <div id="investment-advice-desc">Please provide your contact details. Our financial 
              advisors will be intouch with you.</div>
        </div>


        {this.state.submitted ? (
          
          
					<div className="col-md-6">
          
             
                           <div className="" style={{width:'auto', textAlign: 'center', color:'#67707D'}}>
                              
                              <img src="/img/success.png"></img>
                              <h4>Your message was sent successfully</h4>
                              <h4>Our team will get back to you</h4>
                           </div>
                        </div>

                        
                        
            
            
          
        ) :  (
                    
                      <div className="col-md-6">
          <form className="form">
              <div className="row">
                  <div className="col-md-6">
                      <div className="form-group">
                      <input name="title" id="title"
          required
          value={this.state.title}
          onChange={this.onChangeTitle}
           placeholder="Enter your name" onfocus="this.placeholder = ''" onBlur="this.placeholder = 'Enter your name'" className="form-control"  type="text" />
                      </div>
                  </div>
                  <div className="col-md-6">
                  <div className="form-group">
                  <input name="email" id="email"
          required
          value={this.state.email}
          onChange={this.onChangeEmail}
           placeholder="Enter email address" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,63}$" onfocus="this.placeholder = ''" onBlur="this.placeholder = 'Enter email address'" className="form-control"  type="email" />
                      </div>
                  </div>
              </div>

              <div className="row">
                  <div className="col-md-6">
                      <div className="form-group">
                        <select defaultValue='Saudi Arabia' className="form-control" id="country" onChange={this.onChangeCountry}  required name="country">
                          <option disabled selected>Select Country</option>
                        {countryList.map((List, index) => (
                     <option value={List} >{List}</option>
                     ))}
        
                              
                            </select>
                      </div>
                  </div>
                  <div className="col-md-6">
                      <div className="form-group">
                      <input id="subject"
          required
         
          onChange={this.onChangePhone}
          name="subject" placeholder="Enter phone number" onfocus="this.placeholder = ''" onBlur="this.placeholder = 'Enter your phone number'" className="form-control"  type="text" />
                      </div>
                  </div>
              </div>

              

             

              <div className="row">

              <div className="form-group col-md-6 col-xs-12">        
              <Captcha onChange={this.onChangeCaptcha} defaultValue={this.state.val} placeholder="Enter captcha value" />
              </div>

                  
              </div>
          </form>   
          <div className="row">
          <div className="col-md-12">
                      <div className="form-group">
                          <button onClick={this.saveMessage} className="btn" id="submit-button">Submit</button>
                      </div>
                  </div>
            </div>
          <p style={{color:'green'}} id="successMessage"></p>
                    <p style={{color:'red'}} id="errorMessage"></p>
      </div>
                    
                    
                   
               
)}



        
        
      </div>
</div>

          
       
         
  
                   
                  
                     
    


</div>

    );
}
}
